import React, { Component } from 'react'
import styled from 'styled-components'
import { CtaBtn } from '../../../components'
import { BREAKPOINT } from '../constants'

const Container = styled.div`
  margin: auto;
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  * {
    box-sizing: border-box;
  }
  @media (max-width: ${BREAKPOINT.MEDIUM}) {
    margin: 0;
    .app-container-lrg {
      display: none;
    }
    .main-text {
      width: 100%;
      padding: 0 60px;

      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        margin: 10px 0;
        font-size: 36px;
      }

      h4,
      p {
        font-size: 18px;
        margin: 0;
      }
    }
  }

  @media (max-width: ${BREAKPOINT.SMALL}) {
    .main-text {
      width: 100%;
      padding: 0 10px;

      padding-bottom: 30px;
      margin: auto;
    }
  }
`

const TextContent = styled.div`
  width: 450px;
  text-align: left;
  font-family: SpaceGrotesk, sans-serif;
  padding-top: 75px;

  h4 {
    width: 100%;
    font-size: 22px;
    font-weight: 300;
    margin: 0;
  }

  h2 {
    width: 100%;
    font-size: 48px;
    font-weight: 500;
    margin: 20px 0;
    text-align: left;
  }

  p {
    width: 100%;
    font-size: 24px;
    line-height: 1.5;
    margin: 0;
    text-align: left;
    margin-bottom: 50px;
  }

  button {
    margin: 0;
  }
`

const AppContainer = styled.div`
  position: relative;
  margin-right: 50px;
  height: 450px;

  iframe {
    height: calc(100% + 10px);
    margin-top: 25px;
    margin-left: 0px;
  }
  
`

const AppFrameMed = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-left: 20px;
  margin: 0;

  .app-container-med {
    display: none;
  }

  @media (max-width: ${BREAKPOINT.MEDIUM}) {
    .app-container-med {
      display: block;
      margin-right: -35px;
      margin-bottom: -20px;
      margin-top: 20px;
    }

    img {
      height: 400px;
    }

    iframe {
      height: 365px;
      margin-top: 20px;
      margin-left: -25px;
    }
  }
}
`

const AppFrame = styled.img.attrs({
  src: 'https://www.suki.ai/images/iphone.png'
})`
  pointer-events: none;
  position: absolute;
  top: 12px;
  right: 20px;
  bottom: 50px;
  left: 20px;
  border-radius: 40px;
  overflow: hidden;
  height: 504px;
`

class DemoApp extends Component {
  render () {
    const { handleStart } = this.props
    return (
      <Container>
        <AppContainer className='app-container-lrg'>
          <AppFrame />
          <iframe src='https://player.vimeo.com/video/423334533?wmode=opaque' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen='' />
        </AppContainer>
        <TextContent className='main-text'>
          <h4>Your digital assistant is here.</h4>
          <h2>Meet Suki</h2>
          <p>Suki is an AI-powered, voice-enabled digital assistant that lifts the administrative burden from doctors and increases practice revenue.</p>
          <AppFrameMed>
            <AppContainer className='app-container-med'>
              <AppFrame />
              <iframe src='https://player.vimeo.com/video/423334533?wmode=opaque' frameBorder='0' allow='autoplay; fullscreen' allowFullScreen='' />
            </AppContainer>
          </AppFrameMed>

          <CtaBtn handleClick={handleStart}>Get Started</CtaBtn>
        </TextContent>
      </Container>
    )
  }
}

export default DemoApp
